import type { PrivacyContent } from "./types";

export const privacyZhHant: PrivacyContent = {
  locale: "zh-Hant",
  seo: {
    title: "隱私權政策 - Prismark",
    description: "Prismark 隱私權政策，說明相機、麥克風、相簿等權限的使用方式及資料處理說明。"
  },
  title: "隱私權政策",
  updated: "最後更新：2026-09-13",
  intro: "Prismark 尊重你的隱私。本隱私權政策說明你在使用 Prismark 時，App 如何處理相關資訊。",
  sections: [
    {
      title: "1. 我們收集的資訊",
      body: ["Prismark 不會收集、儲存或上傳你的照片和影片。本 App 在裝置本機提供拍照、影片錄製、雙鏡頭錄影與相簿回看等功能，支援手動參數控制和即時曝光工具。"]
    },
    {
      title: "2. 相機、麥克風與相簿權限",
      body: ["Prismark 可能會請求取用相機，用於拍攝照片和錄製影片。麥克風權限僅用於錄製有聲音的影片。相簿權限僅用於儲存、查看或回看你透過 App 建立的媒體內容。"]
    },
    {
      title: "3. 位置資訊與照片中繼資料",
      body: [
        "Prismark 提供選用功能，可在拍攝照片的中繼資料中記錄位置資訊。該功能預設關閉，只有你主動在 App 設定中開啟後才會生效。",
        "開啟後，Prismark 可能會請求取用裝置的定位服務以取得目前地理位置座標。該位置資料將直接嵌入到新拍攝照片的中繼資料（EXIF）中，並與照片一同儲存在你的裝置本機。",
        "位置資訊僅用於嵌入到你的照片裡。Prismark 不會收集、上傳或與任何伺服器或第三方分享你的位置資料。你可以隨時在 App 設定中關閉該功能；關閉後，新拍攝的照片將不再包含位置中繼資料，但不會影響你已經拍攝的照片中的位置資料。"
      ]
    },
    {
      title: "4. 照片和影片",
      body: ["你的照片和影片會保留在你的裝置上，除非你主動透過系統分享或匯出功能進行操作。Prismark 不會將你的媒體內容上傳到我們的伺服器。"]
    },
    {
      title: "5. 本機資料儲存",
      body: [
        "Prismark 可能會在你的裝置本機儲存 App 設定或偏好，以改善使用體驗。這些設定不會用於識別你的身分。",
        "如果你匯入了自己的 LUT 檔案，Prismark 會在裝置本機的 App 儲存空間裡保留一份副本，以便將它套用到取景框畫面以及你拍攝的照片和影片上。這些檔案只存在你的裝置上，不會上傳到任何地方；你在 App 內刪除該 LUT 或刪除 App 時，它們會一併移除。",
        "你可以透過從裝置中刪除本 App 來移除本機儲存的 App 資料。如果你就隱私或資料刪除事項聯絡我們，我們會根據合理可取得的資訊處理相關請求。"
      ]
    },
    {
      title: "6. 兒童隱私",
      body: ["Prismark 不會有意收集兒童的個人資料。"]
    },
    {
      title: "7. 政策更新",
      body: ["我們可能會不時更新本隱私權政策。任何變更都會發布在本頁面，並更新最後更新時間。"]
    },
    {
      title: "8. 聯絡我們",
      body: ["如果你對本隱私權政策有任何疑問，請透過以下方式聯絡我們：", "axqora@gmail.com"]
    }
  ],
  termsLink: {
    body: "關於 Prismark 的使用規則，請閱讀我們的使用條款。",
    label: "使用條款",
    href: "/zh-Hant/terms"
  }
};
